(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kerabox-heading-style"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = 'main h1,main h2,main h3,main h4,main h5,main .h0,main .h1,main .h2,main .h3,main .h4,main .h5,main [class$="__title"],main [class$="__heading"]';
  const preserve = [['kerabox','KERABOX'],['muràn','Muràn'],['muran','Muràn'],['silky supreme','Silky Supreme'],['spicy shiny','Spicy Shiny'],['spicy reflex','Spicy Reflex'],['spicy blondie','Spicy Blondie'],['spicy curl','Spicy Curl'],['spicy smooth','Spicy Smooth'],['spicy volume','Spicy Volume'],['spicy color','Spicy Color'],['b.tox','B.Tox'],['vipps','Vipps'],['klarna','Klarna']];
  function update(root) {
    const headings = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) headings.unshift(root);
    headings.forEach(heading => {
      if (heading.closest('header,footer') || /eyebrow|subheading|vendor/.test(heading.className)) return;
      if (!heading.matches('h1,h2,h3,h4,h5') && heading.querySelector('h1,h2,h3,h4,h5')) return;
      const text = heading.textContent.trim();
      if (!text || text === text.toLowerCase() || text !== text.toUpperCase()) return;
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      let node, first = true;
      while ((node = walker.nextNode())) {
        let value = node.textContent.toLowerCase();
        if (first && /\p{L}/u.test(value)) {
          value = value.replace(/\p{L}/u, letter => letter.toUpperCase());
          first = false;
        }
        for (const [from,to] of preserve) value = value.replaceAll(from,to).replaceAll(from.charAt(0).toUpperCase()+from.slice(1),to);
        node.textContent = value;
      }
    });
  }
  function init() {
    update(document);
    document.addEventListener('shopify:section:load', event => update(event.target));
    const main = document.querySelector('main');
    if (main) new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) update(node);
      }
    }).observe(main,{childList:true,subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
